export default {
  getDefaultPlans: function () { 
    return [
          {
            name: "Free Internet (1 Hours)",
            time_limit: 3600,
            data_limit: 500,
            price: 0,
            active: true,
            concurrent_devices: 1
          },
          {
            name: "₹ 5 for 1 GB (Validity 1 Day)",
            time_limit: 86400,
            data_limit: 1024,
            price: 5,
            active: true,
            concurrent_devices: 1
          },
          {
            name: "₹ 20 for 10 GB (Validity 7 Day)",
            time_limit: 604800,
            data_limit: 10240,
            price: 20,
            active: false,
            concurrent_devices: 1
          },
          {
            name: "₹ 50 for 100 GB (Validity 28 Day)",
            time_limit: 2419200,
            data_limit: 102400,
            price: 50,
            active: true,
            concurrent_devices: 1
          }
        ]
  }, 
  roundoff: function(val) {
    return Math.floor(val * 100) / 100;
  },
  timeFormat: function (totalSec) {
    if (totalSec > 0) {
      var days = parseInt(totalSec / 86400);
      var hours = parseInt(totalSec / 3600) % 24;
      var minutes = parseInt(totalSec / 60) % 60;
      var result = (days >= 1 ? days + (days === 1 ? ' day ' : ' days ') : '') +
                    (hours >= 1 ? hours + (hours === 1 ? ' hr ' : ' hrs ') : '');
      if (days < 1)
          result += (minutes >= 1 ? minutes + (minutes === 1 ? ' min ' : ' mins ') : '');
      return result ? result : ' less than a minute ';
    }
    return 'None';
  },
  dataFormat: function(dataLeft) {
    let roundoff = function(val) {
      return Math.floor(val * 100) / 100;
    };

    if (dataLeft >= 1073741824) //converting to GB
    { dataLeft = roundoff(dataLeft / 1073741824) + " GB"; }
      else if (dataLeft >= 1048576) //converting to MB
    {
      dataLeft = roundoff(dataLeft / 1048576) + " MB";
    }
    else if (dataLeft >= 1024) //converting to KB
    {
      dataLeft = roundoff(dataLeft / 1024) + " KB";
    }
    return dataLeft;
  },
  findGetParameter(parameterName, urlString=null) {
    var result = '',
      tmp = [];
    var items = location.search
      .substr(1)
      .split("&");
      if (urlString) {
        var ind=urlString.indexOf("?");
        items = urlString.substring(ind+1).split("&");
      }
    for (var index = 0; index < items.length; index++) {
      tmp = items[index].split("=");
      if (tmp[0].toLowerCase() === parameterName.toLowerCase())
        result = decodeURIComponent(tmp[1]);
    }
    return result;
  },
  setCookie: function(cname, cvalue, exdays) {
    //console.log("Setting Cookie : ", cname);
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  getCookie: function(cname) {
    //console.log("Getting Cookie : " + cname);
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  deleteCookie: function(cname) {
    //console.log("deleting cookie", cname);
    document.cookie =
      cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },
  reload: function() {
    location.reload();
  },
  getQueryStringValue: function(key) {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[.+*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  },
  categories: function() {
    var cats = [];
    var subcats = {};
    var categories = {
      hospitality: {
        display: "Hospitality",
        subcategories: {
          hotel: {
            display: "Hotel",
          },
          homestay: {
            display: "HomeStay",
          },
          society: {
            display: "Residential Society",
          },
          pg: {
            display: "Hostel/PG",
          },
        },
      },
      healthcare: {
        display: "Health Care",
        subcategories: {
          hospital: {
            display: "Hospital",
          },
          clinic: {
            display: "Clinic",
          },
          diagnostic: {
            display: "Diagnostic",
          },
        },
      },
      auto: {
        display: "Automobile",
        subcategories: {
          service_center: {
            display: "Service Centre",
          },
          showroom: {
            display: "Showrooms",
          },
        },
      },
      finance: {
        display: "Financial Institution",
        subcategories: {
          bank: {
            display: "bank",
          },
          nbfc: {
            display: "NBFC",
          },
        },
      },
      edutech: {
        display: "Education and Training",
        subcategories: {
          school: {
            display: "Schools",
          },
          coaching: {
            display: "Coaching",
          },
          vocational_training: {
            display: "Vocational Trainings",
          },
          college: {
            display: "Colleges",
          },
        },
      },
      entertainment: {
        display: "Entertainment",
        subcategories: {
          amusement_park: {
            display: "Amusement Park",
          },
          movie_theater: {
            display: "Movie Theater",
          },
          auditorium: {
            display: "Auditoriums",
          },
          gaming_zone: {
            display: "Gaming Zone",
          },
          banquet: {
            display: "Banquet",
          },
        },
      },
      market_place: {
        display: "Market Places",
        subcategories: {
          shopping_mall: {
            display: "Shopping Mall",
          },
          corporate_centre: {
            display: "Corporate Centre",
          },
          high_street: {
            display: "High Street",
          },
          food_court: {
            display: "Food Court",
          },
        },
      },
      fnb: {
        display: "F&B",
        subcategories: {
          pub: {
            display: "Pub",
            microcategories: {
              tea: {
                display: "Tea",
              },
              coffee: {
                display: "Coffee",
              },
              chinese: {
                display: "Chinese",
              },
              burger: {
                display: "Burger",
              },
              mexican: {
                display: "Mexican",
              },
              street_food: {
                display: "Street Food",
              },
              italian: {
                display: "Italian",
              },
              continental: {
                display: "Continental",
              },
              desserts: {
                display: "Desserts",
              },
              beverages: {
                display: "Beverages",
              },
              north_indian: {
                display: "North Indian",
              },
              south_indian: {
                display: "South Indian",
              },
              fast_food: {
                display: "Fast Food",
              },
              lebanese: {
                display: "Lebanese",
              },
              alcohol: {
                display: "Alcohol",
              },
              Salad: {
                display: "Salad",
              },
              sandwiches: {
                display: "Sandwiches",
              },
              bakery: {
                display: "Bakery",
              },
            },
          },
          cafe: {
            display: "Café",
            microcategories: {
              tea: {
                display: "Tea",
              },
              coffee: {
                display: "Coffee",
              },
              chinese: {
                display: "Chinese",
              },
              burger: {
                display: "Burger",
              },
              mexican: {
                display: "Mexican",
              },
              street_food: {
                display: "Street Food",
              },
              italian: {
                display: "Italian",
              },
              continental: {
                display: "Continental",
              },
              desserts: {
                display: "Desserts",
              },
              beverages: {
                display: "Beverages",
              },
              north_indian: {
                display: "North Indian",
              },
              south_indian: {
                display: "South Indian",
              },
              fast_food: {
                display: "Fast Food",
              },
              lebanese: {
                display: "Lebanese",
              },
              alcohol: {
                display: "Alcohol",
              },
              Salad: {
                display: "Salad",
              },
              sandwiches: {
                display: "Sandwiches",
              },
              bakery: {
                display: "Bakery",
              },
            },
          },
          qsr: {
            display: "QSR",
            microcategories: {
              tea: {
                display: "Tea",
              },
              coffee: {
                display: "Coffee",
              },
              chinese: {
                display: "Chinese",
              },
              burger: {
                display: "Burger",
              },
              mexican: {
                display: "Mexican",
              },
              street_food: {
                display: "Street Food",
              },
              italian: {
                display: "Italian",
              },
              continental: {
                display: "Continental",
              },
              desserts: {
                display: "Desserts",
              },
              beverages: {
                display: "Beverages",
              },
              north_indian: {
                display: "North Indian",
              },
              south_indian: {
                display: "South Indian",
              },
              fast_food: {
                display: "Fast Food",
              },
              lebanese: {
                display: "Lebanese",
              },
              alcohol: {
                display: "Alcohol",
              },
              Salad: {
                display: "Salad",
              },
              sandwiches: {
                display: "Sandwiches",
              },
              bakery: {
                display: "Bakery",
              },
            },
          },
          restaurant: {
            display: "Restaurants",
            microcategories: {
              tea: {
                display: "Tea",
              },
              coffee: {
                display: "Coffee",
              },
              chinese: {
                display: "Chinese",
              },
              burger: {
                display: "Burger",
              },
              mexican: {
                display: "Mexican",
              },
              street_food: {
                display: "Street Food",
              },
              italian: {
                display: "Italian",
              },
              continental: {
                display: "Continental",
              },
              desserts: {
                display: "Desserts",
              },
              beverages: {
                display: "Beverages",
              },
              north_indian: {
                display: "North Indian",
              },
              south_indian: {
                display: "South Indian",
              },
              fast_food: {
                display: "Fast Food",
              },
              lebanese: {
                display: "Lebanese",
              },
              alcohol: {
                display: "Alcohol",
              },
              Salad: {
                display: "Salad",
              },
              sandwiches: {
                display: "Sandwiches",
              },
              bakery: {
                display: "Bakery",
              },
            },
          },
          dessert: {
            display: "Sweets and Desserts",
            microcategories: {
              tea: {
                display: "Tea",
              },
              coffee: {
                display: "Coffee",
              },
              chinese: {
                display: "Chinese",
              },
              burger: {
                display: "Burger",
              },
              mexican: {
                display: "Mexican",
              },
              street_food: {
                display: "Street Food",
              },
              italian: {
                display: "Italian",
              },
              continental: {
                display: "Continental",
              },
              desserts: {
                display: "Desserts",
              },
              beverages: {
                display: "Beverages",
              },
              north_indian: {
                display: "North Indian",
              },
              south_indian: {
                display: "South Indian",
              },
              fast_food: {
                display: "Fast Food",
              },
              lebanese: {
                display: "Lebanese",
              },
              alcohol: {
                display: "Alcohol",
              },
              salad: {
                display: "Salad",
              },
              sandwiches: {
                display: "Sandwiches",
              },
              bakery: {
                display: "Bakery",
              },
            },
          },
          stall: {
            display: "Food Stall",
          },
        },
      },
      retail: {
        display: "Retail",
        subcategories: {
          electronics: {
            display: "Electronics",
            microcategories: {
              mobiles: {
                display: "Mobiles",
              },
              computers: {
                display: "Computers",
              },
              home_appliances: {
                display: "Home Appliances",
              },
            },
          },
          street_stall: {
            display: "Street Stalls",
            microcategories: {
              paan_stalls: {
                display: "Paan Stalls",
              },
              kirana_stores: {
                display: "Kirana Stores",
              },
              tea_stalls: {
                display: "Tea Stalls",
              },
              stationery: {
                display: "Stationery",
              },
            },
          },
          mega_store: {
            display: "Mega Store",
          },
          fashion: {
            display: "Fashion",
            microcategories: {
              footwear: {
                display: "Footwear",
              },
              eyewear: {
                display: "Eyewear",
              },
              clothing: {
                display: "Clothing",
              },
              watches: {
                display: "Watches",
              },
              sportswear: {
                display: "Sportswear",
              },
              bags_and_luggage: {
                display: "Bags & Luggage",
              },
              jewellery: {
                display: "Jewellery",
              },
            },
          },
          beauty_n_health: {
            display: "Beauty and Health",
            microcategories: {
              beauty_personalcare: {
                display: "Beauty & Personal Care",
              },
              diet_nutrition: {
                display: "Diet & Nutrition",
              },
            },
          },
          sports_n_fitness: {
            display: "Sports and Fitness",
            microcategories: {
              sports_equipments: {
                display: "Sports Equipments",
              },
              exercise_and_fitness: {
                display: "Exercise and Fitness",
              },
              camping_and_hiking: {
                display: "Camping & Hiking",
              },
            },
          },
          grocery: {
            display: "Grocery",
          },
          toy_n_baby: {
            display: "Toys and Baby products",
            microcategories: {
              toys_and_games: {
                display: "Toys & Games",
              },
              baby_products: {
                display: "Baby Products",
              },
              kids_fashion: {
                display: "Kids Fashion",
              },
            },
          },
          pharma: {
            display: "pharmaceutical",
          },
          home_n_furniture: {
            display: "Home and Furniture",
            microcategories: {
              home_furnishing: {
                display: "Home Furnishing",
              },
              home_decor: {
                display: "Home Décor",
              },
              furniture: {
                display: "Furniture",
              },
              pet_supplies: {
                display: "Pet Supplies",
              },
            },
          },
        },
      },
      travel: {
        display: "Travel Services",
        subcategories: {
          bus: {
            display: "Bus",
          },
          cab: {
            display: "Cab",
          },
        },
      },
      workplace: {
        display: "Workplace",
        subcategories: {
          office: {
            display: "Office",
          },
          cowork: {
            display: "Co-workingspace",
          },
          i2e1: {
            display: "i2e1",
          },
        },
      },
      wellness: {
        display: "Personal Services",
        subcategories: {
          gym: {
            display: "Gym",
          },
          salon: {
            display: "Salon and Spa",
          },
          laundry: {
            display: "Laundry and dry cleaners",
          },
        },
      },
      telecom: {
        display: "Telecommunication",
        subcategories: {
          relationship_centre: {
            display: "Relationship Centre",
          },
        },
      },
    };

    for (var cat in categories) {
      cats.push({ id: cat, name: categories[cat].display });
      subcats[cat] = [];
      var subcategories = categories[cat].subcategories;
      for (var subcat in subcategories) {
        subcats[cat].push({ id: subcat, name: subcategories[subcat].display });
        //cats[index].subcategories.push({id: subcat, name: subcategories[subcat].display });
      }
    }
    return { categories: cats, subcategories: subcats };
  },
};
